export default __webpack_public_path__ + "static/media/home automation.19af9525.jpg";